import { API_BASE_URL } from "../config";

const buildUrl = (path, params = {}) => {
	const url = new URL(`${API_BASE_URL || "http://localhost:5000"}${path}`);
	Object.entries(params).forEach(([key, value]) => {
		if (value === undefined || value === null || value === "") return;
		url.searchParams.set(key, String(value));
	});
	return url.toString();
};

export const getUserAnalyticsDashboard = async (params = {}) => {
	try {
		const token = localStorage.getItem("token");
		const url = buildUrl("/openpanel-analytics/user-dashboard", params);
		const response = await fetch(url, {
			method: "GET",
			cache: "no-store",
			headers: {
				"Content-Type": "application/json",
				...(token ? { Authorization: `Bearer ${token}` } : {}),
			},
		});

		const payload = await response.json().catch(() => ({}));

		if (!response.ok) {
			return {
				success: false,
				status: response.status,
				message:
					payload?.message ||
					payload?.error_message ||
					`Failed to load user analytics (${response.status})`,
			};
		}

		return payload;
	} catch (error) {
		return {
			success: false,
			message: error?.message || "Failed to load user analytics.",
		};
	}
};

export const postUserAnalyticsEvent = async (eventName, properties = {}) => {
	try {
		const token = localStorage.getItem("token");
		if (!token) return; // backend route requires auth; skip pre-login events

		await fetch(buildUrl("/openpanel-analytics/track"), {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ eventName, properties }),
			keepalive: true,
		});
	} catch (_error) {
		console.error(_error);
	}
};
